Array.prototype.first = function() {
    if( this.length ) return this[0];
    return null;
}

Array.prototype.last = function() {
    if( this.length ) return this[this.length - 1];
    return null;
}